module.exports = __webpack_public_path__ + "img/gg.d0289dc0.png";